<template>
  <div>

    <div v-if=" isDevelopment ">
      <button @click="setLocale('es')">ES</button> - <button @click="setLocale('en')">EN</button> <router-link :to="{ name: 'login' } " class="btn">Login</router-link> Locale: {{ getLocale }}
      
      <!-- {{ getApiUrl }}
      {{ process }} -->
    </div>

    <div v-if="loading">
      <spinner></spinner>
    </div>

    <div v-else v-for=" (line, index) in menuItems " :key="index" :class=" { 'sidebar_widget': true, 'mt-30': (index > 1) ? true : false }">
      <div :class=" 'product_menu bg_' + line.lin_nick ">
        <h3 class="line"><router-link :to="{ name: 'line', params: { language: getLocale, lin: setUrlParams(line.lin_id, line.lin_name) } }">{{ line.lin_name }}</router-link><button @click="setActiveLine(line.lin_id)" class="cbtn btn-angle-right"><i class="fa fa-angle-right"></i></button>
        </h3>
        <div class="product_menu_inner">
          <transition name="fade"> 
            <ul>
              <!-- v-show=" line.lin_id == getLine " -->
              <li v-for=" (ctg, index) in line.categories " :key="index" class="categorie_list "><router-link :to="{ name: 'category', params: { language: getLocale, lin: setUrlParams(line.lin_id,line.lin_name), ctg: setUrlParams(ctg.ctg_id,ctg.ctg_name) } }">{{ ctg.ctg_name }}</router-link><button @click="setActiveCategory(line.lin_id, ctg.ctg_id)" class="cbtn btn-angle-right"><i class="fa fa-angle-right"></i></button>
                <transition name="fade">              
                  <ul v-show=" ctg.ctg_id == getCategoryId && line.lin_id == getLineId " class="subcategorie">
                    <li v-for=" (sct, index) in ctg.subcategories " :key="index" class="categorie_list">
                      <router-link :to="{ name: 'subcategory', params: { language: getLocale, lin: setUrlParams(line.lin_id,line.lin_name), ctg: setUrlParams(ctg.ctg_id,ctg.ctg_name), sct: setUrlParams(sct.sct_id,sct.sct_name)  } }">{{ sct.sct_name }}</router-link>
                    </li>
                  </ul>
                </transition>
              </li>              
            </ul>
          </transition>  
        </div>
      </div>
    </div>
  </div>
</template>      

<script>
  import Spinner from '../helpers/Spinner.vue';

  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import { mixinGlobal } from './../../mixins/mixinGlobal';

	export default {   
    mixins: [ mixinGlobal ], 
    components: { Spinner },
  	data: () => {
      return {
        menuItems: [],
        activeLine: 0,
        activeCategory: 0,
        activeSubcategory: 0,
        loading: false,
      };
    },
    mounted(){
      this.loadData();
    },
    computed: {	
      ...mapGetters( ['getLocale', 'getLocale', 'getApiUrl', 'getBaseUrl', 'getLineId', 'getCategoryId', 'getSubcategoryId', 'getTypeId'] ),
      isDevelopment: function(){
        return process.env.NODE_ENV  == 'development' ? true : false
      }	,
      process: function(){
        return process.env.VUE_APP_API_URL
      },
    },
    methods: {
      ...mapActions(['setLocale']),
      loadData(){
        this.startLoading();

        this.$axios.get(this.getApiUrl + 'menu.php')
        .then( (respuesta) =>{  

          this.menuItems = respuesta.data;   
          this.stopLoading();

        })  
        .catch( (error) =>{ 
          // Global mixin
          alert(JSON.stringify(error))
        })           
      },
      setActiveCategory(lineId, ctgId){
        this.activeLine = lineId;
        if( this.activeCategory == ctgId){
          this.activeCategory = 0;
        }else{
          this.activeCategory = ctgId;
        }
      },
      setActiveLine(lineId){        
        if( this.activeLine == lineId){
          this.activeLine = 0;
        }else{
          this.activeLine = lineId;
        }
      },
      setLocale(value){
        this.$store.dispatch('setLocale', { locale: value, i18n: this.$i18n } )
      }
    },
    watch:{
      $route (to, from){
        /*console.log(to);*/

        if( to.params.language != from.params.language ){
          this.loadData()
        }

        if ('lin' in to.params) {
          this.activeLine = ( to.params.lin.substring(0, to.params.lin.indexOf('-')) );
        }else{ this.activeLine = 0 }

        if ('ctg' in to.params) {
          this.activeCategory = ( to.params.ctg.substring(0, to.params.ctg.indexOf('-')) );
        }else{ this.activeCategory = 0 }

        if ('sct' in to.params) {
          this.activeSubcategory = ( to.params.sct.substring(0, to.params.sct.indexOf('-')) );
        }else{ this.activeSubcategory = 0 }
      
        /*console.log(this.activeLine)
        console.log(this.activeCategory)
        console.log(this.activeSubcategory)*/
      },
      getLocale(oldVale, newVal){
        this.loadData()
      }
    }
  }
</script>

<style type="text/css">
  .fade-enter-active, .fade-leave-active {
    max-height: 800px;
    transition: all 1s;
    opacity: 100;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    max-height: 0;
    transition: all 0.3s ease-out;
    opacity: 0;
  }
</style>